import { render, staticRenderFns } from "./selectGift.vue?vue&type=template&id=52f2357c&scoped=true&"
import script from "./selectGift.vue?vue&type=script&lang=js&"
export * from "./selectGift.vue?vue&type=script&lang=js&"
import style0 from "./selectGift.vue?vue&type=style&index=0&id=52f2357c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f2357c",
  null
  
)

export default component.exports